// extracted by mini-css-extract-plugin
export default {"model":"Model_model__9dGyE","model__view":"Model_model__view__tmtSz"};